import { Dialog, DialogContent, DialogTitle, Typography, useTheme } from '@mui/material';
import DiscountOrderForm from '../../form/discount-order';

interface SimpleDialogProps {
  open: boolean;
  selectedValue: string;
  onSave: any;
  onClose: (value: string) => void;
  invoices: any;
}

export function GeneralDiscount(props: SimpleDialogProps) {
  const { onClose, selectedValue, open, invoices, onSave } = props;
  const handleClose = () => {
    onClose(selectedValue);
  };

  const { typography } = useTheme();

  const handleSubmit = async (dataForm: Record<string, unknown>) => {
    await onSave(dataForm);
    handleClose();
  };
  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={{ ...typography.h6 }} textAlign="center">
          DESCUENTO
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DiscountOrderForm invoices={invoices} onSave={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}
